import { apiSlice } from "./apiSlice";

import { BILLING_URL } from "../constants";

export const billingApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // =====================================================
    // Generate Invoice
    // POST /api/billing/invoices/generate/:coachingCenterId
    // =====================================================

    generateInvoice: builder.mutation({
      query: (coachingCenterId) => ({
        url: `${BILLING_URL}/invoices/generate/${coachingCenterId}`,
        method: "POST",
      }),

      invalidatesTags: ["BillingInvoice"],
    }),

    // =====================================================
    // Regenerate Invoice
    // PUT /api/billing/invoices/:invoiceId/regenerate
    // =====================================================

    regenerateInvoice: builder.mutation({
      query: (invoiceId) => ({
        url: `${BILLING_URL}/invoices/${invoiceId}/regenerate`,
        method: "PUT",
      }),

      invalidatesTags: ["BillingInvoice"],
    }),

    // =====================================================
    // Mark Invoice Paid
    // PUT /api/billing/invoices/:invoiceId/pay
    // =====================================================

    markInvoicePaid: builder.mutation({
      query: ({ invoiceId, data }) => ({
        url: `${BILLING_URL}/invoices/${invoiceId}/pay`,
        method: "PUT",
        body: data,
      }),

      invalidatesTags: ["BillingInvoice"],
    }),

    // =====================================================
    // Cancel Invoice
    // PUT /api/billing/invoices/:invoiceId/cancel
    // =====================================================

    cancelInvoice: builder.mutation({
      query: ({ invoiceId, reason }) => ({
        url: `${BILLING_URL}/invoices/${invoiceId}/cancel`,
        method: "PUT",
        body: {
          reason,
        },
      }),

      invalidatesTags: ["BillingInvoice"],
    }),

    // =====================================================
    // Product Admin - Get Invoice Details
    // GET /api/billing/invoices/:invoiceId
    // =====================================================

    getInvoiceDetails: builder.query({
      query: (invoiceId) => ({
        url: `${BILLING_URL}/invoices/${invoiceId}`,
      }),

      providesTags: ["BillingInvoice"],

      keepUnusedDataFor: 5,
    }),

    // =====================================================
    // Product Admin - Get Invoice List
    // GET /api/billing/invoices
    // =====================================================

    getInvoices: builder.query({
      query: (params) => ({
        url: `${BILLING_URL}/invoices`,
        params,
      }),

      providesTags: ["BillingInvoice"],

      keepUnusedDataFor: 5,
    }),

    // =====================================================
    // Coaching Center - Get Invoice List
    // GET /api/billing/coaching-center/invoices
    // =====================================================

    getCoachingCenterInvoices: builder.query({
      query: (params) => ({
        url: `${BILLING_URL}/coaching-center/invoices`,
        params,
      }),

      providesTags: ["BillingInvoice"],

      keepUnusedDataFor: 5,
    }),

    // =====================================================
    // Coaching Center - Get Invoice Details
    // GET /api/billing/coaching-center/invoices/:invoiceId
    // =====================================================

    getCoachingCenterInvoiceById: builder.query({
      query: (invoiceId) => ({
        url: `${BILLING_URL}/coaching-center/invoices/${invoiceId}`,
      }),

      providesTags: (result, error, invoiceId) => [
        { type: "BillingInvoice", id: invoiceId },
      ],

      keepUnusedDataFor: 5,
    }),
  }),
});

export const {
  useGenerateInvoiceMutation,
  useRegenerateInvoiceMutation,
  useMarkInvoicePaidMutation,
  useCancelInvoiceMutation,

  useGetInvoiceDetailsQuery,
  useGetInvoicesQuery,

  useGetCoachingCenterInvoicesQuery,
  useGetCoachingCenterInvoiceByIdQuery,
} = billingApiSlice;